import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  effect,
  inject
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

import { UserBonusState } from '@app/modules/payment/user-bonus.state';
import { NumberPipe } from '@core/common/pipes';
import { MediaQueryService } from '@app/@core/breakpoints';
import { AuthState } from '@app/modules/users';

@Component({
  selector: 'deposit-banner',
  templateUrl: './deposit-banner.component.html',
  styleUrl: './deposit-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'w-full' },
  imports: [
    RouterLink,
    NumberPipe,
    NgTemplateOutlet
  ]
})
export default class DepositBannerComponent {
  public readonly userBonusState = inject(UserBonusState);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  public readonly authState = inject(AuthState);

  private readonly mediaService = inject(MediaQueryService);
  public isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));

  constructor() {
    this.loadUserBonuses();
  }

  public secretCode: string | undefined;

  private readonly secretCodeEffect = effect(() => {
    const currentSecretCode = this.userBonusState.secretCode();

    if (!currentSecretCode) {
      return;
    }

    this.secretCode = currentSecretCode.code;
    this.cdr.detectChanges();
  });

  private loadUserBonuses(): void {
    this.userBonusState.loadUserBonuses().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
